import { useFetchQuery } from "common/queries/hooks";

import { LoyaltyProgramMarketingBanner } from "../types";
import { keys, urls } from "./constants";

export const useLoyaltyProgramBannersQuery = () => {
  return useFetchQuery<LoyaltyProgramMarketingBanner[]>(keys.loyaltyProgramBannersLists(), {
    fetch: { url: urls.loyaltyProgramBanners() },
  });
};
